<template>
  <div>
    <div class="mass-action-settings">

      <el-popconfirm
        confirm-button-text='Да'
        cancel-button-text='нет'
        icon="el-icon-question"
        title="Вы уверены, что хотите удалить цели?"
        @confirm="doAction"
      >
        <el-button
          slot="reference"
          size="small"
          type="primary"
        >
          Удалить
        </el-button>

      </el-popconfirm>

    </div>

    <mass-action-result
      v-if="result"
      :result="result"
    ></mass-action-result>

  </div>
</template>

<script>
import {ActionTemplateMixin} from "@/components/massActions/actionTemplates/ActionTemplateMixin";
import MassActionResult from "@/components/massActions/MassActionResult.vue";

export default {
  name: "card-element-delete-action",
  mixins: [ActionTemplateMixin],
  components: {MassActionResult},

  data() {
    return {}
  },
  methods: {},
}
</script>
